import Layout from "../Layout";
import React from "react";

export const Home = () => {
    return (
        <div>
            <Layout />
        </div>
    );
}
